
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GeneratorPage = lazy(() => import('../pages/generator/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const MemberPage = lazy(() => import('../pages/member/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/generator',
    element: <GeneratorPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/member',
    element: <MemberPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
